import Api, { ApiConfig } from '@/api/base/api'
import { CancelTokenSource } from 'axios'

class WholesaleApi extends Api {
  public cancelToken: CancelTokenSource | null = null

  constructor(configs?: ApiConfig & { baseURL?: string }) {
    super({
      baseURL: `${process.env.VUE_APP_SERVER_ENDPOINT_MDM}`,
      ...configs,
    })
  }

  /**
   * 매장 위치 - 건물명 조회
   */
  getBuildings() {
    return this.requestGet<Wholesale.WholesaleResponse>('/buildings')
  }

  /**
   * 매장 위치 - 층 조회
   * @param buildingNo 건물 번호
   */
  getFloors(buildingNo: number) {
    return this.requestGet<Wholesale.WholesaleResponse>(`/buildings/${buildingNo}/floors`)
  }

  /**
   * 도매처 등록
   * @param payload 매장등록 정보
   */
  postShops(payload: Wholesale.AdminWholesaleShopCreate) {
    return this.requestPost<Wholesale.MdmResponseWrapper<Wholesale.WholesaleShopSimple>>(`/shops`, payload)
  }

  /**
   * 도매처 목록 조회
   * @param params 도매처 목록 조회 파라미터
   */
  getWholesaleShops(params: Wholesale.RequestShopList) {
    return this.requestGet<Wholesale.MdmResponseWrapper<Wholesale.ResponseCommonList<Wholesale.AdminWholesaleShop>>>('/shops', params)
  }

  /**
   * 도매처 상세 조회
   * @param shopId 도매처(공급처) 매장 번호
   */
  getShopDetail(shopId: number) {
    return this.requestGet<Wholesale.MdmResponseWrapper<Wholesale.WholesaleShopDetail>>(`/shops/${shopId}`, {
      masked: 'N',
    })
  }

  /**
   * 등록 > 사업자정보(도매처) 검색 조회
   * @param params 사업자정보(도매처) 검색 조회 파라미터
   */
  getWholesales(params: Wholesale.RequestWholeSaleFilter) {
    return this.requestGet<Wholesale.MdmResponseWrapper<Wholesale.ResponseCommonList<Wholesale.ResponseWholesale>>>(`/wholesales`, params)
  }

  /**
   * 상품등록 > 도매명 검색 조회
   * @param params 도매처 검색 조회 파라미터
   */
  getShops(params: Wholesale.RequestWholeSaleFilter) {
    return this.requestGet<Wholesale.MdmResponseWrapper<Wholesale.ResponseCommonList<Wholesale.ResponseWholesaleShops>>>(`/shops`, params)
  }
}

export default WholesaleApi
